import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {DialogContentBase, DialogModule, DialogRef, KENDO_DIALOGS} from '@progress/kendo-angular-dialog';
import {EditorModule} from '@progress/kendo-angular-editor';
import {InputsModule} from '@progress/kendo-angular-inputs';
import {ButtonsModule} from '@progress/kendo-angular-buttons';
import {LabelModule} from '@progress/kendo-angular-label';
import {DropDownsModule} from '@progress/kendo-angular-dropdowns';
import {LayoutModule} from '@progress/kendo-angular-layout';
import {AutoFocusDirective} from '../../../directives/auto-focus.directive';
import {CasiCloseOptions, FormModes} from '../../../common/constants.lib';
import {LoggerService} from '../../../shared/logger.service';
import {QuestionOption} from '../../../models/models.lib';

@Component({
  selector: 'casi-question-option.component',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    DialogModule,
    EditorModule,
    InputsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    LayoutModule,
    AutoFocusDirective,
    KENDO_DIALOGS
  ],
  templateUrl: './question-option.component.html',
  styleUrl: './question-option.component.scss'
})
export class QuestionOptionComponent  extends DialogContentBase implements OnInit {

  private _questionOption: QuestionOption | undefined;

  @Input() title: string = 'Title Not Set';

  @Input({ required: true }) set questionOption(val: QuestionOption) {
    this._questionOption = val;
    this.editForm.patchValue(this._questionOption);
  }
  get questionOption(): QuestionOption | undefined {
    return this._questionOption;
  };

  private _mode: FormModes = FormModes.NOTSET;
  @Input({ required: true }) set mode(val: FormModes) {
    this._mode = val;
  }
  get mode(): FormModes {
    return this._mode;
  };

  editForm: FormGroup;

  constructor(
    public override dialog: DialogRef,
    private fb: FormBuilder,
    private logger: LoggerService,
  ) {
    super(dialog);
    this.editForm = this.fb.group(
      {
        sort_order: [-1, []],
        option: [null, [Validators.required]]
      }
    );
  }

  //#region Form

  get f() {
    return this.editForm.controls;
  }
  get option() {
    return this.editForm.get('option');
  }

  //#endregion

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');
  }

  public onCancelAction(): void {
    this.logger.debug(`onCancelAction...`);
    this.dialog.close({ text: CasiCloseOptions.Cancelled });
  }

  public onSaveAction(): void {
    this.logger.debug(`onSaveAction...`, this.editForm.value);
    if (this.editForm.invalid) {
      this.editForm.markAllAsTouched();
      return;
    }
    this.dialog.close({text: CasiCloseOptions.Saved, data: this.editForm.value});
  }
}


